import React from "react";
import ProductsComponent from "./ProductsComponent";
import {
  CATEGORY_LIST,
  ADD_PRODUCT,
  ADD_PRICE,
  UPDATE_PRODUCT_IMAGE,
  MENU_LIST,
  SUBCATEGORY_LIST,
  HOST,
  // HOST,
} from "../../Network/ApiPaths";
// import postDataResponse from "../../Network/PostDataResponse";
// import getResponse from "../../Network/GetDataResponse";
import Uri from "../../Network/Uri";
import postClientDataResponse from "../../Network/PostClientDataResponse";
import getResponseClient from "../../Network/GetClientDataResponse";
// import setClientDataResponse from "../../Network/SetClientDataResponse";
let storeFresh;
//let clientHost;

class ProductsContainer extends React.Component {
  constructor(props) {
    super();

    const client = window.localStorage.getItem("clientAccess");
    storeFresh = JSON.parse(client);
    // if (storeFresh !== null) {
    //   clientHost = JSON.parse(window.localStorage.getItem("clientAccess")).host;
    // }

    this.state = {
      filteredProducts: [],
      selectedImages: [],
      reset: false,
      products: [],
      categories: [],
      subCategories: [],
      selectedCatId: "",
      // constant: "s",
      selectedSubCatId: "",
      collapse: false,
      editedCat: false,
      cName: "all",
      // onUpdateDetails: "",
      name: "",
      store: "",
      type: "",
      description: "",
      tax: "",
      itemDefaultDetails: "",
      itemDefaultPrices: "",
      img: "",
      newName: "",
      newStore: "",
      newType: "",
      newDesc: "",
      newTax: "",
      updatedName: "",
      updatedStore: "",
      updatedType: "",
      updatedDesc: "",
      updatedTax: "",
      dID: "",
      dPID: "",
      newPriceQuantity: "",
      newPriceMeasure: "",
      newPrice: "",
      newPriceOffer: "",
      newPID: "",
      priceQuantity: "",
      priceMeasure: "",
      pricePrice: "",
      priceOffer: "",
      new: false,
      productDeleted: false,
      productUpdated: false,
      priceDeleted: false,
      priceUpdated: false,
      priceAdded: false,
      file: null,
      searchValue: "",
    };
  }
  searchInitiate = (iName) => {
    this.setState({ searchValue: iName });
    if (iName) {
      this.onSearch(iName);
    } else {
      this.setState({ filteredProducts: [] });
    }
  };
  onSearch = (itemName) => {
    let allProducts = this.state.products;
    const filteredData = allProducts.filter((product) => {
      let info = product.info;
      return (
        info.name.toLowerCase().includes(itemName.toLowerCase()) &&
        info.store_id === storeFresh.storeId
      );
    });
    // if (itemName === "" || (null && this.state.selectedCatId !== ""))
    //   this.setState({ filteredProducts: this.state.products });  else
    this.setState({ filteredProducts: filteredData });
  };
  getProducts = () => {
    var apiPath = new Uri(HOST + MENU_LIST).addQueryParam(
      "store_id",
      storeFresh.storeId
    );
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        if (this.state.selectedSubCatId !== "") {
          this.setState({
            products: onSuccessResponse.result,
            // .filter(
            //   (q) => q.info.category_id === this.state.selectedCatId)
            reset: false,
            filteredProducts: onSuccessResponse.result.filter(
              (q) =>
                q.info.category_id === this.state.selectedCatId &&
                q.info.sub_category_id === this.state.selectedSubCatId
            ),
          });
        } else {
          this.setState({
            selectedImages: [],
            img: "",
            products: onSuccessResponse.result,
            // .filter(
            //   (q) => q.info.category_id === this.state.selectedCatId)
            reset: false,
            filteredProducts: onSuccessResponse.result.filter(
              (q) => q.info.category_id === this.state.selectedCatId
            ),
          });
        }
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  };
  getSubCategories = (selectedCatId) => {
    var apiPath = new Uri(HOST + SUBCATEGORY_LIST)
      .addQueryParam("catId", selectedCatId)
      .addQueryParam("store_id", storeFresh.storeId);
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        this.setState({
          subCategories: onSuccessResponse.result,
        });
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  };
  updateImages = (e) => {
    let a = this.state.selectedImages;
    let b = this.state.img;
    ["image_path", "image_one", "image_two", "image_three", "image_four"].map(
      (d, index) => {
        if (a.includes(b.info[d])) {
          this.handleUpdateImage(e, b, d);
        }
      }
    );
  };
  handleUpdateImage = (e, p, path) => {
    let img = e.target.files[0];
    const handleImageRead = async (event) => {
      const file = img;
      const base64 = await this.convertBase64(file);
      let requestBody = {
        id: p.info.id,
        image: base64,
        [path]: base64,
      };
      postClientDataResponse(
        HOST + UPDATE_PRODUCT_IMAGE,
        storeFresh.key,
        requestBody,
        (onSuccessResponse) => {
          this.getProducts();
        },
        (onError) => {
          console.log(onError.message);
        }
      );
    };
    handleImageRead();
  };
  selectImage = (imgs) => {
    let a = this.state.selectedImages;
    if (a.includes(imgs)) {
      let b = a.filter((el) => {
        return el !== imgs;
      });
      this.setState({
        selectedImages: b,
      });
    } else {
      this.setState({
        selectedImages: [...this.state.selectedImages, imgs],
      });
    }
    console.log("checking", a);
    // a.forEach(function (value) {
    //   if (a.indexOf(value) == -1)
    //     this.setState({
    //       selectedImages: [...this.state.selectedImages, imgs],
    //     });
    //   else {
    //     let b = a.splice(a.indexOf(value), 1);
    //     this.setState({
    //       selectedImages: b,
    //     });
    //   }
    // });
  };
  // deleteImages = (e) => {
  //   let a = this.state.selecteddeleteImages;
  //   let b = this.state.deleteimg;
  //   ["image_path", "image_one", "image_two", "image_three", "image_four"].map(
  //     (d, index) => {
  //       if (a.includes(b.info[d])) {
  //         this.handleDeleteImage(e, b, d);
  //       }
  //     }
  //   );
  // };
  // handleDeleteImage = (e, p, path) => {
  //   let img = e.target.files[0];
  //   const handleImageRead = async (event) => {
  //     const file = img;
  //     const base64 = await this.convertBase64(file);
  //     let requestBody = {
  //       id: p.info.id,
  //       image: base64,
  //       [path]: base64,
  //     };
  //     postClientDataResponse(
  //       clientHost + UPDATE_PRODUCT_IMAGE,
  //       storeFresh.key,
  //       requestBody,
  //       (onSuccessResponse) => {
  //         this.getProducts();
  //       },
  //       (onError) => {
  //         console.log(onError.message);
  //       }
  //     );
  //   };
  //   handleImageRead();
  // };
  // selectDeleteImage = (imgs) => {
  //   let a = this.state.selectedDeleteImages;
  //   if (a.includes(imgs)) {
  //     let b = a.filter((el) => {
  //       return el !== imgs;
  //     });
  //     this.setState({
  //       selectedDeleteImages: b,
  //     });
  //   } else {
  //     this.setState({
  //       selectedDeleteImages: [...this.state.selectedDeleteImages, imgs],
  //     });
  //   }
  //   console.log("checking", a);
  //   // a.forEach(function (value) {
  //   //   if (a.indexOf(value) == -1)
  //   //     this.setState({
  //   //       selectedImages: [...this.state.selectedImages, imgs],
  //   //     });
  //   //   else {
  //   //     let b = a.splice(a.indexOf(value), 1);
  //   //     this.setState({
  //   //       selectedImages: b,
  //   //     });
  //   //   }
  //   // });
  // };
  selectedCatID = (sCatId, sCatName) => {
    this.setState({
      selectedCatId: sCatId,
      selectedSubCatId: "",
      // constant: "",
      cName: sCatName,
      collapse: true,
      new: true,
    });
    this.getSubCategories(sCatId);
    // var apiPath = new Uri(clientHost + MENU_LIST).addQueryParam(
    //   "storeid",
    //   storeFresh.storeId
    // );
    // ?category_id=${sCatId}&limit=10&offset=0`
    // ).addQueryParam("store_id", storeFresh.storeId);
    // getResponseClient(
    //   apiPath,
    //   storeFresh.key,
    //   (onSuccessResponse) => {
    //     this.setState({
    //       products: onSuccessResponse.result.filter(
    //         (q) => q.info.category_id === sCatId
    //       ),
    //       filteredProducts: onSuccessResponse.result.filter(
    //         (q) => q.info.category_id === sCatId
    //       ),
    //       collapse: false,
    //     });
    //   },
    //   (onError) => {
    //     console.log(onError.message);
    //   }
    // );
  };

  selectedSubCatID = (sSubCatId) => {
    // this.setState({
    //   selectedSubCatId: sSubCatId,
    //   // cName: sCatName,
    //   // collapse: true,
    //   // new: true,
    // });
    var apiPath = new Uri(HOST + MENU_LIST).addQueryParam(
      "store_id",
      storeFresh.storeId
    );
    // .addQueryParam("category_id", this.state.selectedCatId)
    // .addQueryParam("sub_category_id", sSubCatId);
    // ?category_id=${sCatId}&limit=10&offset=0`
    // ).addQueryParam("store_id", storeFresh.storeId);
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        // console.log(
        //   this.state.filteredProducts.filter(
        //     (q) => q.info.sub_category_id === sSubCatId
        //   ),
        //   this.state.filteredProducts,
        //   sSubCatId
        // );
        if (onSuccessResponse.status === true) {
          if (sSubCatId === "") {
            this.setState({
              products: onSuccessResponse.result.filter(
                (q) => q.info.category_id === this.state.selectedCatId
              ),
              filteredProducts: onSuccessResponse.result.filter(
                (q) => q.info.category_id === this.state.selectedCatId
              ),
              selectedSubCatId: sSubCatId,
            });
          } else {
            this.setState({
              products: onSuccessResponse.result.filter(
                (q) =>
                  q.info.category_id === this.state.selectedCatId &&
                  q.info.sub_category_id === sSubCatId
              ),
              filteredProducts: onSuccessResponse.result.filter(
                (q) =>
                  q.info.category_id === this.state.selectedCatId &&
                  q.info.sub_category_id === sSubCatId
              ),
              selectedSubCatId: sSubCatId,
            });
          }
        } else {
          this.setState({
            products: [],
            filteredProducts: [],
            selectedSubCatId: sSubCatId,
          });
        }
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  };

  next = (offset) => {
    if (this.state.selectedCatId === "") {
      this.setState({
        products: [],
      });
    } else {
      var apiPath = new Uri(
        HOST +
          `Menu/listmenu?category_id=${this.state.selectedCatId}&limit=10&offset=${offset}`
      );
      getResponseClient(
        apiPath,
        (onSuccessResponse) => {
          this.setState({
            products: onSuccessResponse.result,
          });
        },
        (onError) => {
          // alert(onError.message);
        }
      );
    }
  };
  fieldChange = (e) => this.setState({ [e.target.name]: e.target.value });
  onUpdatePrices = (e) => {
    let priceUpdatedQuantity;
    let priceUpdatedMeasure;
    let priceUpdatedPrice;
    let priceUpdatedOffer;
    if (this.state.priceQuantity === "") {
      priceUpdatedQuantity = this.state.itemDefaultPrices.quantity;
    } else {
      priceUpdatedQuantity = this.state.priceQuantity;
    }
    if (this.state.priceMeasure === "") {
      priceUpdatedMeasure = this.state.itemDefaultPrices.measure;
    } else {
      priceUpdatedMeasure = this.state.priceMeasure;
    }
    if (this.state.pricePrice === "") {
      priceUpdatedPrice = this.state.itemDefaultPrices.price;
    } else {
      priceUpdatedPrice = this.state.pricePrice;
    }
    if (this.state.priceOffer === "") {
      priceUpdatedOffer = this.state.itemDefaultPrices.offer;
    } else {
      priceUpdatedOffer = this.state.priceOffer;
    }
    if (
      (this.state.priceQuantity === "" ||
        this.state.priceQuantity === this.state.itemDefaultPrices.quantity) &&
      (this.state.priceMeasure === "" ||
        this.state.priceMeasure === this.state.itemDefaultPrices.measure) &&
      (this.state.pricePrice === "" ||
        this.state.pricePrice === this.state.itemDefaultPrices.price) &&
      (this.state.priceOffer === "" ||
        this.state.priceOffer === this.state.itemDefaultPrices.offer)
    ) {
      alert("no changes to update");
    } else {
      // this.setState({
      //   priceUpdated: true,
      // });
      // POST API WITH DATA
      const requestBody = {
        id: this.state.itemDefaultPrices.id,
        quantity: priceUpdatedQuantity,
        measure: priceUpdatedMeasure,
        price: priceUpdatedPrice,
        offer: priceUpdatedOffer,
        product_id: this.state.itemDefaultPrices.product_id,
        store_id: storeFresh.storeId,
      };
      postClientDataResponse(
        HOST + ADD_PRICE,
        storeFresh.key,
        requestBody,
        (onSuccessResponse) => {
          this.getProducts(this.state.selectedCatId);
          this.setState({
            reset: true,
            priceUpdated: true,
          });
          // if (onSuccessResponse.status === true) {
          //   this.setState({
          //     products: onSuccessResponse.result.filter(
          //       (q) => q.info.category_id === presentCatId
          //     ),
          //     collapse: false,
          //     new: true,
          //   });
          // } else {
          //   this.setState({
          //     products: onSuccessResponse.result.filter(
          //       (q) => q.info.category_id === presentCatId
          //     ),
          //     collapse: false,
          //     new: true,
          //   });
          // }
        },
        (onError) => {
          // alert(onError);
        }
      );
    }

    // if (
    //   this.state.priceQuantity === "" ||
    //   this.state.priceQuantity === null ||
    //   this.state.priceQuantity === undefined
    // ) {
    //   alert("Enter Quantity");
    // } else if (
    //   this.state.priceMeasure === "" ||
    //   this.state.priceMeasure === null ||
    //   this.state.priceMeasure === undefined
    // ) {
    //   alert("Enter Measure");
    // } else if (
    //   this.state.pricePrice === "" ||
    //   this.state.pricePrice === null ||
    //   this.state.pricePrice === undefined
    // ) {
    //   alert("Enter Price");
    // } else if (
    //   this.state.priceOffer === "" ||
    //   this.state.priceOffer === null ||
    //   this.state.priceOffer === undefined
    // ) {
    //   alert("Enter Offer");
    // } else {
    //   // POST API WITH DATA
    //   const requestBody = {
    //     id: this.state.itemDefaultPrices.id,
    //     quantity: this.state.priceQuantity,
    //     measure: this.state.priceMeasure,
    //     price: this.state.pricePrice,
    //     offer: this.state.priceOffer,
    //   };
    //   postClientDataResponse(
    // clientHost +
    //     ADD_PRICE,
    //     requestBody,
    //     (onSuccessResponse) => {
    //       alert(onSuccessResponse);
    //       console.log(onSuccessResponse);
    //     },
    //     (onError) => {
    //       alert(onError);
    //     }
    //   );
    // }
  };
  onUpdateDetails = (e) => {
    let updatedProductName;
    let updatedProductType;
    let updatedProductDesc;
    let updatedProductTax;
    
    updatedProductName = this.state.updatedName;
  
    updatedProductType = this.state.updatedType;
    
    updatedProductDesc = this.state.updatedDesc;
    
    updatedProductTax = this.state.updatedTax;
    
    if (
      (updatedProductName === "" || this.state.itemDefaultDetails.name) &&
      (updatedProductType === "" || this.state.itemDefaultDetails.type) &&
     
      (updatedProductDesc === "" ||
        this.state.itemDefaultDetails.description) &&
      (updatedProductTax === "" || this.state.itemDefaultDetails.tax)
    ) {
      alert("no details are changed");
    } else {
      let productData = this.state.itemDefaultDetails;
      console.log(productData.info.id);
      const requestBody = {
        id: productData.info.id,
        name: updatedProductName,
        type: updatedProductType,
        description: updatedProductDesc,
        tax: updatedProductTax,
        store_id: storeFresh.storeId,
      };
      postClientDataResponse(
        // clientHost + UPDATE_USER_DETAILS,
        HOST + ADD_PRODUCT,
        storeFresh.key,
        requestBody,
        (onSuccessResponse) => {
          this.getProducts();
          this.setState({
            reset: true,
            updatedProduct: true,
          });
        }
      );
    }
  };

  // alert(
  //   this.state.itemDefaultDetails +
  //     this.state.updatedName +
  //     this.state.updatedStore +
  //     this.state.updatedType +
  //     this.state.updatedDesc +
  //     this.state.updatedTax
  // );
  // e.preventDefault();
  // alert(this.state.itemDefaultDetails.info.name);
  // alert(this.state.name);
  // this.setState({
  //   store: this.state.store,
  //   name: this.state.name,
  //   type: this.state.type,
  //   description: this.state.description,
  //   tax: this.state.tax,
  // });
  // if (this.state.name === "") {
  //   alert("name not changed");
  // } else {
  //   alert("name changed");
  // }
  // if (
  //   this.state.store === "" ||
  //   this.state.store === null ||
  //   this.state.store === undefined
  // ) {
  //   alert("store");
  // } else {
  // }
  // // POST API WITH DATA
  // const requestBody = {
  //   onUpdateDetails: this.state.onUpdateDetails,
  //   addon_status: "NO",
  //   status: "ACTIVE",
  // };
  // postClientDataResponse(
  // clientHost +
  //   ADD_CATEGORY,
  //   requestBody,
  //   (onSuccessResponse) => {
  //     alert(onSuccessResponse);
  //     console.log(onSuccessResponse);
  //   },
  //   (onError) => {
  //     alert(onError);
  //   }
  // );
  //   this.setState({
  //     reset: true,
  //     productUpdated: true,
  //   });
  //   this.getProducts(this.state.selectedCatID);
  // };

  // onUpdatePrices = (e) => {
  //   // e.preventDefault();
  //   // this.setState({
  //   //   store: this.state.store,
  //   //   name: this.state.name,
  //   //   type: this.state.type,
  //   //   description: this.state.description,
  //   //   tax: this.state.tax,
  //   // });
  // };
  onProductPrices = (e) => {
    this.setState({
      newPID: e.info.id,
    });
    // console.log(e);
  };

  onProductDelete = (e) => {
    this.setState({
      productDeleted: true,
    });
    var apiPath = new Uri(
      HOST + `Menu/deleteProduct?id=${this.state.dID}`
    ).addQueryParam("store_id", storeFresh.storeId);
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        this.getProducts(this.state.selectedCatId);
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  };
  // onPriceDelete = (e) => {
  //   var apiPath = new Uri(clientHost +HOST + `Menu/deleteProduct?id=${this.state.dID}`);
  //    getResponseClient(
  //     apiPath,
  //     (onSuccessResponse) => {
  //       alert(onSuccessResponse);
  //     },
  //     (onError) => {
  //       alert(onError.message);
  //     }
  //   );
  // };
  onProductImages = (e) => {
    // console.log("checking", e);
    // e.preventDefault();
    this.setState({
      img: e,
      // store: this.state.store,
    });
  };
  onProductDetails = (e) => {
    // e.preventDefault();
    this.setState({
      itemDefaultDetails: e,
      store: this.state.store,
      name: this.state.name,
      type: this.state.type,
      description: this.state.description,
      tax: this.state.tax,
    });
  };
  onAddNewProduct = () => {
    if (
      this.state.newName === "" ||
      this.state.newName === null ||
      this.state.newName === undefined
    ) {
      alert("Enter Name");
    } else if (
      this.state.newType === "" ||
      this.state.newType === null ||
      this.state.newType === undefined
    ) {
      alert("Enter Type");
    } else if (
      this.state.newDesc === "" ||
      this.state.newDesc === null ||
      this.state.newDesc === undefined
    ) {
      alert("Enter Description");
    }
    // else if (
    //   this.state.newStore === "" ||
    //   this.state.newStore === null ||
    //   this.state.newStore === undefined
    // ) {
    //   alert("Enter Store");
    // }
    else if (
      this.state.newTax === "" ||
      this.state.newTax === null ||
      this.state.newTax === undefined
    ) {
      alert("Enter Tax Value");
    } else {
      // let productDet = this.state.itemDefaultDetails;
      // POST API WITH DATA
      const requestBody = {
        // sub_category_id: "",
        tax: this.state.newTax,
        category_id: this.state.selectedCatId,
        sub_category_id: this.state.selectedSubCatId,
        name: this.state.newName,
        type: this.state.newType,
        description: this.state.newDesc,
        status: "ACTIVE",
        store_id: storeFresh.storeId,
      };

      postClientDataResponse(
        HOST + ADD_PRODUCT,
        storeFresh.key,
        requestBody,
        (onSuccessResponse) => {
          this.setState({
            reset: true,
          });
          // alert(onSuccessResponse);
          // console.log(onSuccessResponse);
          this.getProducts(this.state.selectedCatId);
        },
        (onError) => {
          //  console.log(onError);
        }
      );
    }
  };
  onProductTriggerDelete = (e) => {
    this.setState({
      dID: e.info.id,
    });
  };
  onPriceTriggerDelete = (e) => {
    // console.log(e);
    this.setState({
      itemDefaultPrices: e,
    });
  };
  deletePrice = () => {
    var apiPath = new Uri(
      HOST + `Menu/deletePrice?id=${this.state.itemDefaultPrices.id}`
    );
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        // alert(onSuccessResponse);
        this.getProducts();
        this.setState({
          priceDeleted: true,
        });
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  };
  convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  handleChange = (e, p) => {
    // console.log(e.target.files[0].name)\
    let img = e.target.files[0];
    // let reader = new FileReader();
    ////////////////////
    const handleFileRead = async (event) => {
      const file = img;
      const base64 = await this.convertBase64(file);
      let requestBody;
      if (p.info.image_path === "") {
        requestBody = {
          id: p.info.id,
          image: base64,
          image_path: base64,
        };
      } else if (p.info.image_one === "") {
        requestBody = {
          id: p.info.id,
          image: base64,
          image_one: base64,
        };
      } else if (p.info.image_two === "") {
        requestBody = {
          id: p.info.id,
          image: base64,
          image_two: base64,
        };
      } else if (p.info.image_three === "") {
        requestBody = {
          id: p.info.id,
          image: base64,
          image_three: base64,
        };
      } else {
        requestBody = {
          id: p.info.id,
          image: base64,
          image_four: base64,
        };
      }
      postClientDataResponse(
        HOST + UPDATE_PRODUCT_IMAGE,
        storeFresh.key,
        requestBody,
        (onSuccessResponse) => {
          this.getProducts();
        },
        (onError) => {
          console.log(onError.message);
        }
      );
    };
    handleFileRead();
  };
  onAddNewPrice = (e) => {
    if (
      this.state.newPriceQuantity === "" ||
      this.state.newPriceQuantity === null ||
      this.state.newPriceQuantity === undefined
    ) {
      alert("Enter Quantity");
    } else if (
      this.state.newPriceMeasure === "" ||
      this.state.newPriceMeasure === null ||
      this.state.newPriceMeasure === undefined
    ) {
      alert("Enter Measure");
    } else if (
      this.state.newPrice === "" ||
      this.state.newPrice === null ||
      this.state.newPrice === undefined
    ) {
      alert("Enter Price");
    } else if (
      this.state.newPriceOffer === "" ||
      this.state.newPriceOffer === null ||
      this.state.newPriceOffer === undefined
    ) {
      alert("Enter Offer");
    } else {
      this.setState({
        priceAdded: true,
      });
      const requestBody = {
        // sub_category_id: "",
        quantity: this.state.newPriceQuantity,
        measure: this.state.newPriceMeasure,
        offer: this.state.newPriceOffer,
        price: this.state.newPrice,
        product_id: this.state.newPID,
        store_id: storeFresh.storeId,
        // store_id: storeFresh.storeId,
      };
      postClientDataResponse(
        HOST + ADD_PRICE,
        storeFresh.key,
        requestBody,
        (onSuccessResponse) => {
          this.setState({
            reset: true,
          });
          this.getProducts(this.state.selectedCatId);
        },
        (onError) => {
          alert(onError);
        }
      );
    }
  };
  onChangeProductStatus = (p) => {
    // if (p.status === "ACTIVE") {
    //   this.deletePin(p.id);
    // } else {
    // console.log(p);
    console.log(p.info);

    let requestBody;
    if (p.info.is_deleted === "N") {
      requestBody = {
        id: p.info.id,
        is_deleted: "Y",
      };
    } else {
      requestBody = {
        id: p.info.id,
        is_deleted: "N",
      };
    }
    postClientDataResponse(
      HOST + ADD_PRODUCT,
      storeFresh.key,
      requestBody,
      (onSuccessResponse) => {
        this.getProducts();
      },
      (onError) => {
        console.log(onError);
      }
    );
    // }
  };

  // handleBulk = (e) => {
  //   let file = e.target.files[0];
  //   this.setState({ file });
  // };
  // uploadBulk = () => {
  //   let file = this.state.file;
  //   let formdata = new FormData();
  //   formdata.append("file", file);
  //   axios({
  //     url:
  //       "http://ec2-3-21-71-127.us-east-2.compute.amazonaws.com:8080/api/excel/Items",
  //     method: "POST",
  //     data: formdata,
  //   }).then(
  //     (res) => {
  //       console.log(res);
  //       this.getProducts(this.state.selectedCatId);
  //     },
  //     (err) => {
  //       console.log(err);
  //     }
  //   );
  // };
  render() {
    return (
      <>
        <ProductsComponent
          // data={this.state.products}
          // constant={this.state.constant}
          data={this.state.filteredProducts}
          catData={this.state.categories}
          selectedCat={this.selectedCatID}
          subCatData={this.state.subCategories}
          selectedSubCat={this.selectedSubCatID}
          selectedSubCatId={this.state.selectedSubCatId}
          catid={this.state.selectedCatId}
          cname={this.state.cName}
          collapse={this.state.collapse}
          next={this.next}
          fieldChange={this.fieldChange}
          onUpdateDetails={this.onUpdateDetails}
          onUpdatePrices={this.onUpdatePrices}
          handleChange={this.handleChange}
          // handleClick={this.handleClick}
          // onUpdatePrice={this.onUpdatePrice}
          onAddPrice={this.onAddPrice}
          deletePrice={this.deletePrice}
          onProductDetails={this.onProductDetails}
          onProductImages={this.onProductImages}
          onProductPrices={this.onProductPrices}
          onProductDelete={this.onProductDelete}
          itemDefaultDetails={this.state.itemDefaultDetails}
          img={this.state.img}
          itemDefaultPrices={this.state.itemDefaultPrices}
          addNewProduct={this.onAddNewProduct}
          onProductTriggerDelete={this.onProductTriggerDelete}
          onPriceTriggerDelete={this.onPriceTriggerDelete}
          onAddNewPrice={this.onAddNewPrice}
          selectedImages={this.state.selectedImages}
          updateImages={this.updateImages}
          // selectedDeleteImages={this.state.selectedDeleteImages}
          // deleteImages={this.deleteImages}
          selectImage={this.selectImage}
          new={this.state.new}
          productDeleted={this.state.productDeleted}
          productUpdated={this.state.productUpdated}
          priceDeleted={this.state.priceDeleted}
          priceUpdated={this.state.priceUpdated}
          priceAdded={this.state.priceAdded}
          reset={this.state.reset}
          searchInitiate={this.searchInitiate}
          searchValue={this.state.searchValue}
          onChangeProductStatus={this.onChangeProductStatus}
          // handleBulk={this.handleBulk}
          // uploadBulk={this.uploadBulk}
        />
      </>
    );
  }
  getCategories = () => {
    var apiPath = new Uri(HOST + CATEGORY_LIST).addQueryParam(
      "store_id",
      storeFresh.storeId
    );
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        this.setState({ categories: onSuccessResponse.result });
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  };
  async componentDidMount() {
    this.getCategories();
    this.getProducts();
  }
}

export default ProductsContainer;
